import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profile", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold pb-3" }, "Professional Summary", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)
const _hoisted_4 = { class: "sticky flex bottom-0 z-100 w-full p-2 bg-white shadow-md dark:bg-primary-black" }

import { arrowBackCircle } from "ionicons/icons"
  import { IonBackButton, IonTextarea } from "@ionic/vue"
  import { ref, computed, onMounted } from "vue"
  import { useUserStore } from "@/store/user"
  import { generateSchema } from "@/utils/validate"
  import jwt from "@/utils/jwt"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import FormTemplate from "@/components/template/formTemplate.vue"
  import WbTextArea from "@/components/template/TextAreaTemplate.vue"

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalContainer',
  setup(__props) {

  const userStore = useUserStore()

  // initilize resources
  const nbf = ref(jwt.generateNBF())
  const profile = computed<any>({
    get: () => userStore.customerDetails.profile,
    set: (val) => userStore.setCustomerDetails({ profile: val }),
  })

  // inputs
  const input = ref({
    bio: "",
  })

  const bioDetails = computed(() => ({
    bio: profile.value.bio || "",
  }))

  const bioSchema = generateSchema([
    {
      name: "bio",
      rule: "stringOptional",
    },
  ])

  /**
   * save bio
   */
  const saveBio = () => {
    profile.value.bio = input.value.bio
    const bioData = {
      profile: {
        bio: profile.value.bio,
      },
    }
    userStore.saveCustomerDetails(nbf.value, bioData)
    userStore.retrieveProfileDetails("bio")
  }

  onMounted(() => {
    userStore.retrieveProfileDetails("bio")
    input.value.bio = bioDetails.value.bio
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton), {
                  class: "text-gray-300 pl-3",
                  text: ``,
                  icon: _unref(arrowBackCircle)
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(FormTemplate, {
          "validation-schema": _unref(bioSchema),
          "initial-values": JSON.parse(JSON.stringify(_unref(bioDetails))),
          class: "flex flex-col min-h-screen",
          onValid: saveBio
        }, {
          default: _withCtx(() => [
            _createVNode(CardTemplate, { class: "mx-4 my-6" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(WbTextArea, {
                  modelValue: input.value.bio,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input.value.bio) = $event)),
                  "hide-toolbar": true,
                  name: "bio",
                  placeholder: "Write about yourself, your relevant experience, skills and achievements."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_button, {
                expand: "block",
                color: "white",
                type: "submit",
                "native-type": "submit",
                class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"])
      ]),
      _: 1
    })
  ], 64))
}
}

})